var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Page"},[_c('div',{staticClass:"Page-Content"},[_c('img',{staticStyle:{"width":"100%","display":"block"},attrs:{"src":require("@/assets/location/drone.png"),"alt":""}})])])
}]

export { render, staticRenderFns }